export const menuData = [
  {
    headTitle: 'dashboard'
  },
  {
    path: `${import.meta.env.BASE_URL}dashboard`,
    title: 'menu.dashboard',
    type: 'link',
    icon: 'ti-home',
    active: true,
    defaultActive: false
  },
  {
    path: `${import.meta.env.BASE_URL}projects`,
    title: 'menu.projects',
    type: 'link',
    icon: 'ti-briefcase',
    active: true,
    defaultActive: false
  },
  {
    title: 'menu.budge',
    icon: 'ti-money',
    type: 'sub',
    active: false,
    defaultActive: false,
    children: [
      {
        path: `${import.meta.env.BASE_URL}budge/create`,
        title: 'budge.tab_budget',
        type: 'link',
        icon: 'ti-money',
        specificRoleVerification: true,
        active: false,
        defaultActive: false
      },
      {
        path: `${import.meta.env.BASE_URL}budge/compare`,
        title: 'budge.tab_compare',
        type: 'link',
        icon: 'ti-money',
        specificRoleVerification: true,
        active: false,
        defaultActive: false
      }
    ]
  },
  {
    title: 'menu.supplying.text',
    icon: 'ti-list',
    type: 'sub',
    active: false,
    defaultActive: false,
    children: [
      {
        title: 'menu.supplying.requests.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        children: [
          {
            path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/my-request-materials`,
            title: 'menu.supplying.requests.my_requests',
            type: 'link',
            external: true,
            active: false,
            defaultActive: false
          },
          {
            title: 'menu.supplying.requests.generate_request.text',
            type: 'sub',
            badgeClass: 'bg-warning',
            badgeValue: '3',
            active: false,
            defaultActive: false,
            children: [
              {
                path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/sap/request-materials`,
                title: 'menu.supplying.requests.generate_request.material_requests',
                type: 'link',
                external: true,
                active: false,
                defaultActive: false
              },
              {
                path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/request-materials/return-materials`,
                title: 'menu.supplying.requests.generate_request.return_materials',
                type: 'link',
                external: true,
                active: false,
                defaultActive: false
              },
              {
                path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/requests-transfer/date-delivery`,
                title: 'menu.supplying.requests.generate_request.transfer_requests',
                type: 'link',
                external: true,
                active: false,
                defaultActive: false
              },
              {
                path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/form/suppliers`,
                title: 'menu.supplying.requests.generate_request.supplier_request',
                type: 'link',
                external: true,
                active: false,
                defaultActive: false
              },
              {
                path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/form/materials`,
                title: 'menu.supplying.requests.generate_request.supplier_material',
                type: 'link',
                external: true,
                active: false,
                defaultActive: false
              },
              {
                path: `${import.meta.env.BASE_URL}consumption/materials`,
                title: 'menu.supplying.requests.generate_request.consumption',
                type: 'link',
                active: false,
                roleVerification: true,
                defaultActive: false
              }
            ]
          },
          {
            path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/request-materials/approvals`,
            title: 'menu.supplying.requests.approvals',
            type: 'link',
            external: true,
            active: false,
            defaultActive: false
          },
          {
            path: `${import.meta.env.BASE_URL}supplying/field-reception`,
            title: 'menu.supplying.requests.field_reception.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false
          },
          {
            path: `${import.meta.env.BASE_URL}supplying/deliveries`,
            title: 'menu.supplying.requests.deliveries.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false
          }
        ]
      },
      {
        title: 'menu.supplying.module_cd.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        children: [
          {
            path: `${import.meta.env.BASE_URL}supplying/cd/transfer-requests`,
            title: 'menu.supplying.module_cd.transfer_requests.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false
          }
        ]
      },
      {
        title: 'menu.supplying.module_purchase.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        children: [
          {
            path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/purchase-requests`,
            title: 'menu.supplying.module_purchase.purchase_requests',
            type: 'link',
            external: true,
            active: false,
            defaultActive: false
          }
        ]
      },
      {
        title: 'menu.supplying.mobile_store.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        children: [
          {
            path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/mobile-warehouses/requests`,
            title: 'menu.supplying.mobile_store.requests',
            type: 'link',
            external: true,
            active: false,
            defaultActive: false
          },
          {
            path: `${import.meta.env.VITE_APP_URL_PROJECTS_PLATAFORM}/supplying/mobile-warehouses/material-transfers`,
            title: 'menu.supplying.mobile_store.transfers',
            type: 'link',
            external: true,
            active: false,
            defaultActive: false
          },
          {
            path: `${import.meta.env.BASE_URL}supplying/mobile-warehouses/stock`,
            title: 'menu.supplying.mobile_store.stock',
            type: 'link',
            external: false,
            active: true,
            defaultActive: false
          }
        ]
      },
      {
        title: 'menu.supplying.reports.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        children: [
          {
            title: 'menu.supplying.reports.reports_users.text',
            type: 'sub',
            badgeClass: 'bg-warning',
            badgeValue: '3',
            active: false,
            defaultActive: false,
            children: [
              {
                path: `${import.meta.env.BASE_URL}supplying/reports/stock`,
                title: 'menu.supplying.reports.reports_users.stock',
                type: 'link',
                external: false,
                active: true,
                defaultActive: false
              },
              {
                path: `${import.meta.env.BASE_URL}supplying/reports/products`,
                title: 'menu.supplying.reports.reports_users.materials',
                type: 'link',
                external: false,
                active: true,
                defaultActive: false
              }
            ]
          },
          {
            title: 'menu.supplying.reports.supplying.text',
            type: 'sub',
            badgeClass: 'bg-warning',
            badgeValue: '3',
            active: false,
            defaultActive: false,
            children: [
              {
                path: `${import.meta.env.BASE_URL}supplying/requests/dashboard`,
                title: 'menu.supplying.reports.supplying.requests',
                type: 'link',
                external: false,
                active: false,
                defaultActive: false
              }
            ]
          }
        ]
      },
      {
        title: 'menu.supplying.maintainers.virtual_stores_consumption.text',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        defaultActive: false,
        specificRoleVerification: true,
        children: [
          {
            path: `${import.meta.env.BASE_URL}virtual-stores-consumption/reports`,
            title: 'menu.supplying.maintainers.virtual_stores_consumption.reports',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}maintainers/virtual-stores-consumption`,
            title: 'menu.supplying.maintainers.virtual_stores_consumption.maintainer_stores',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          }
        ]
      },
      {
        path: `${import.meta.env.BASE_URL}supplying/otif-fill-rate`,
        title: 'menu.supplying.fill_rate.text',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false
      }
    ]
  },
  {
    title: 'menu.epp.title',
    icon: 'ti-shield',
    type: 'sub',
    active: false,
    defaultActive: false,
    specificRoleVerification: true,
    children: [
      {
        path: `${import.meta.env.BASE_URL}epp`,
        title: 'menu.epp.req',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}epp/prevencionistas`,
        title: 'menu.epp.list',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}epp/configurar-prevencionistas`,
        title: 'menu.epp.conf',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      }
    ]
  },
  {
    title: 'menu.rrhh',
    icon: 'ti-user',
    type: 'sub',
    active: false,
    specificRoleVerification: true,
    children: [
      {
        path: `${import.meta.env.BASE_URL}human-resources/employees`,
        title: 'menu.banns',
        type: 'link',
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}human-resources/Historico`,
        title: 'menu.rrhh_history',
        type: 'link',
        specificRoleVerification: true
      }
    ]
  },
  {
    title: 'menu.inspector.text',
    icon: 'ti-view-grid',
    type: 'sub',
    active: false,
    defaultActive: false,
    children: [
      {
        title: 'menu.supplying.reports.text',
        path: `${import.meta.env.BASE_URL}inspector/dashboard`,
        type: 'link',
        external: false,
        active: false,
        defaultActive: false
      }
    ]
  },
  {
    title: 'menu.quality.text',
    icon: 'ti-check',
    type: 'sub',
    active: false,
    defaultActive: false,
    children: [
      {
        path: `${import.meta.env.BASE_URL}quality/dashboard`,
        title: 'menu.quality.info.text',
        type: 'link',
        external: false,
        active: false,
        specificRoleVerification: false,
        defaultActive: false
      },
      {
        path: `${import.meta.env.BASE_URL}quality/answers`,
        title: 'menu.quality.answers.text',
        type: 'link',
        external: false,
        active: false,
        specificRoleVerification: true,
        defaultActive: false
      },
      {
        path: `${import.meta.env.BASE_URL}quality/projects`,
        title: 'menu.quality.projects.text',
        type: 'link',
        external: false,
        active: false,
        specificRoleVerification: true,
        defaultActive: false
      },
      {
        title: 'menu.quality.maintainers',
        type: 'sub',
        badgeClass: 'bg-warning',
        badgeValue: '2',
        active: false,
        specificRoleVerification: true,
        defaultActive: false,
        children: [
          {
            path: `${import.meta.env.BASE_URL}quality/business-units`,
            title: 'menu.quality.business_unit.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/mangement-areas`,
            title: 'menu.quality.mangement_area.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/document-types`,
            title: 'menu.quality.document_type.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/disciplines`,
            title: 'menu.quality.disciplines.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/documents`,
            title: 'menu.quality.documents.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/users`,
            title: 'menu.quality.users.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          },
          {
            path: `${import.meta.env.BASE_URL}quality/maintainers/templates`,
            title: 'menu.quality.templates.text',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          }
        ]
      }
    ]
  },
  {
    title: 'menu.customer_service.text',
    icon: 'ti-comments',
    type: 'sub',
    active: false,
    defaultActive: false,
    children: [
      {
        title: 'menu.customer_service.c_and_i',
        type: 'sub',
        active: false,
        defaultActive: false,
        specificRoleVerification: true,
        children: [
          {
            path: `${import.meta.env.BASE_URL}bills`,
            title: 'menu.customer_service.bills',
            type: 'link',
            external: false,
            active: false,
            defaultActive: false,
            specificRoleVerification: true
          }
        ]
      }
    ]
  },
  {
    path: `${import.meta.env.BASE_URL}disagreements`,
    title: 'menu.disagreements.text',
    type: 'link',
    icon: 'ti-alert',
    active: true,
    defaultActive: false,
    specificRoleVerification: true
  },
  {
    path: `${import.meta.env.BASE_URL}payments-sec`,
    title: 'menu.payments_sec.text',
    type: 'link',
    icon: 'ti-wallet',
    active: true,
    defaultActive: false
  },
  {
    path: `${import.meta.env.BASE_URL}api-bank-chile`,
    title: 'menu.apiBankChile.text',
    type: 'link',
    icon: 'ti-credit-card',
    active: true,
    defaultActive: false,
    specificRoleVerification: false
  },
  {
    title: 'menu.proforma_billing.text',
    icon: 'ti-receipt',
    type: 'sub',
    active: false,
    defaultActive: false,
    specificRoleVerification: true,
    children: [
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/proforma`,
        title: 'menu.proforma_billing.list',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/invoices`,
        title: 'menu.proforma_billing.invoices',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },

      {
        path: `${import.meta.env.BASE_URL}proforma-billing/distribuidoras`,
        title: 'menu.proforma_billing.distribuidoras',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/resumen-esco`,
        title: 'menu.proforma_billing.resumen_esco',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/monitoring`,
        title: 'menu.proforma_billing.monitoring',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      },
      {
        path: `${import.meta.env.BASE_URL}proforma-billing/informes-clientes`,
        title: 'menu.proforma_billing.informes',
        type: 'link',
        external: false,
        active: false,
        defaultActive: false,
        specificRoleVerification: true
      }
    ]
  },
  {
    title: 'menu.sipe.text',
    icon: 'ti-receipt',
    type: 'sub',
    active: false,
    defaultActive: false,
    specificRoleVerification: true,
    children: [
      {
        title: 'menu.sipe.kpi_ejecucion',
        path: `${import.meta.env.BASE_URL}sipe/kpi-ejecucion`,
        type: 'link',
        specificRoleVerification: true
      }
    ]
  },
  {
    path: 'https://ti.helpdesk.fluxsolar.cl/servicedesk/customer/portals',
    title: 'menu.help_desk',
    type: 'link',
    icon: 'ti-help-alt',
    active: true,
    external: true,
    defaultActive: false
  },
  {
    path: `${import.meta.env.BASE_URL}tutoriales`,
    title: 'menu.tutorials',
    type: 'link',
    icon: 'ti-eye',
    active: true,
    external: true,
    defaultActive: false
  },
  {
    path: `${import.meta.env.BASE_URL}sec/`,
    title: 'menu.sec',
    type: 'link',
    icon: 'ti-write',
    active: true,
    defaultActive: false,
    specificRoleVerification: true
  },
  {
    title: 'menu.interconnections.title',
    icon: 'ti-plug',
    type: 'sub',
    active: false,
    specificRoleVerification: true,
    children: [
      {
        title: 'menu.interconnections.residencial',
        path: `${import.meta.env.BASE_URL}interconexiones/residencial`,
        specificRoleVerification: true,
        type: 'link'
      },
      {
        title: 'menu.interconnections.ci',
        path: `${import.meta.env.BASE_URL}interconexiones/ci`,
        specificRoleVerification: true,
        type: 'link'
      }
    ]
  },
  {
    path: `${import.meta.env.BASE_URL}maintainers/roles`,
    title: 'menu.managment_roles',
    type: 'link',
    icon: 'ti-user',
    active: true,
    defaultActive: false,
    specificRoleVerification: true
  },
  {
    path: `https://s3.amazonaws.com/proyecto.fluxsolar.cl/manual-de-usuario/plataforma-de-proyectos.pdf`,
    title: 'menu.user_manual',
    type: 'link',
    icon: 'ti-file',
    active: true,
    external: true,
    defaultActive: false
  },
  {
    path: `${import.meta.env.BASE_URL}disagreements`,
    title: 'menu.disagreements.text',
    type: 'link',
    icon: 'ti-alert',
    active: true,
    defaultActive: false,
    specificRoleVerification: true
  }
  // {
  //   path: `${import.meta.env.BASE_URL}gestion-cdv`,
  //   title: 'menu.cdv',
  //   type: 'link',
  //   icon: 'ti-write',
  //   active: true,
  //   defaultActive: false,
  //   specificRoleVerification: true
  // }
]
